module.exports = __webpack_public_path__ + "static/media/headphones.b2bf5ef1.svg";